import { useState, useRef } from 'react';
import XTable from 'components/XTable';
import { Modal, InputNumber, notification } from 'antd';
import { getNursingBedListApi, postNursingBedApi } from 'api/nursingBed';
import XForm from 'components/XForm';
import { getFilterText } from 'utils';
import { nursingAreas } from 'enumeration/nursingAreas';

const formTailLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};
const NursingBedMGT = () => {
    const xTableRef = useRef();
    const xFormRef = useRef();
    const [editVisible, seteditVisible] = useState(false);
    const [editLoading, seteditLoading] = useState(false);
    const [editInfo, seteditInfo] = useState({});

    const editModalShow = rowData => {
        const {
            applyCheckIn = 0,
            remaining = 0,
            waitForApprove = 0,
            id,
            nursingArea,

            poor = 0,
            isolate = 0,
            total = 0,
        } = rowData;
        const nursingAreaText = getFilterText(nursingAreas, nursingArea);
        seteditVisible(true);
        setTimeout(() => {
            seteditInfo({ id, nursingAreaText });
            xFormRef.current.form?.setFieldsValue({
                applyCheckIn,
                remaining,
                waitForApprove,
                total,
                poor,
                isolate,
            });
        }, 0);
    };

    // 确认修改
    const editOk = () => {
        xFormRef.current.form?.submit();
    };

    // 执行床位变更
    const onFinish = values => {
        const { id } = editInfo;
        seteditLoading(true);
        postNursingBedApi({ ...values, id }).then(res => {
            if (res.success) {
                notification.success({
                    message: '床位变更成功。',
                });
                seteditVisible(false);
                xTableRef.current.refreshTable && xTableRef.current.refreshTable();
            }
            seteditLoading(false);
        });
    };

    const onCancel = () => {
        xFormRef.current.form?.setFieldsValue({
            applyCheckIn: 0,
            remaining: 0,
            waitForApprove: 0,
            total: 0,
            reserved: 0,
        });
        seteditInfo({});
        seteditVisible(false);
    };

    const columns = [
        {
            title: '床位类型',
            dataIndex: 'nursingArea',
            render: val => getFilterText(nursingAreas, val, val),
        },
        {
            title: '现入住人数',
            dataIndex: 'applyCheckIn',
        },
        {
            title: '剩余床位',
            dataIndex: 'remaining',
        },
        {
            title: '轮候人数',
            dataIndex: 'waitForApprove',
        },
        {
            title: '特困床位',
            dataIndex: 'poor',
        },
        {
            title: '隔离床位',
            dataIndex: 'isolate',
        },
        {
            title: '总床位数',
            dataIndex: 'total',
        },
        {
            title: '操作',
            dataIndex: '',
            render: (val, rowData) => {
                return (
                    <span className="actionText" onClick={() => editModalShow(rowData)}>
                        床位变更
                    </span>
                );
            },
        },
    ];

    const onValuesChange = () => {
        if (!xFormRef) return;
        const values = xFormRef.current.form?.getFieldsValue();
        const { applyCheckIn, isolate, total } = values;
        const remaining = total - isolate - applyCheckIn;
        xFormRef.current.form?.setFieldsValue({
            remaining,
        });
    };

    const formItems = [
        {
            formItemApis: {
                label: '现入住人数',
                name: 'applyCheckIn',
                rules: [{ required: true }],
            },
            item: <InputNumber min={0} precision={0} style={{ width: 200 }} />,
        },
        {
            formItemApis: {
                label: '剩余床位数',
                name: 'remaining',
                rules: [{ required: true }],
            },
            item: <InputNumber min={0} precision={0} style={{ width: 200 }} />,
        },
        {
            formItemApis: {
                label: '轮候人数',
                name: 'waitForApprove',
                rules: [{ required: true }],
            },
            item: <InputNumber min={0} precision={0} style={{ width: 200 }} />,
        },
        {
            formItemApis: {
                label: '特困床位',
                name: 'poor',
                rules: [{ required: true }],
            },
            item: <InputNumber min={0} precision={0} style={{ width: 200 }} />,
        },
        {
            formItemApis: {
                label: '隔离床位',
                name: 'isolate',
                rules: [{ required: true }],
            },
            item: <InputNumber min={0} precision={0} style={{ width: 200 }} />,
        },
        {
            formItemApis: {
                label: '总床位数量',
                name: 'total',
                rules: [{ required: true }],
            },
            item: <InputNumber min={0} precision={0} style={{ width: 200 }} />,
        },
    ];
    return (
        <div>
            <XTable
                columns={columns}
                api={getNursingBedListApi}
                rowKey="id"
                dataTotalKeys={[
                    'applyCheckIn',
                    'remaining',
                    'waitForApprove',
                    'poor',
                    'isolate',
                    'total',
                ]}
                dataTotalObj={totals => {
                    return {
                        nursingArea: '合计',
                        applyCheckIn: totals.applyCheckIn,
                        remaining: totals.remaining,
                        waitForApprove: totals.waitForApprove,
                        poor: totals.poor,
                        isolate: totals.isolate,
                        total: totals.total,
                    };
                }}
                pagination={false}
                ref={xTableRef}
            />
            <Modal
                title={`${editInfo.nursingAreaText}床位变更`}
                centered
                wrapClassName="modalBox"
                visible={editVisible}
                onOk={editOk}
                okButtonProps={{ loading: editLoading }}
                onCancel={onCancel}>
                <XForm
                    formApis={{
                        ...formTailLayout,
                        name: 'editBad',
                        onFinish: onFinish,
                        onValuesChange: onValuesChange,
                    }}
                    formItems={formItems}
                    ref={xFormRef}
                />
            </Modal>
        </div>
    );
};
export default NursingBedMGT;
